<template>
<div class="chapter">
<div class="inner_page">
<a id="page_ii">
</a><p class="Dedication"><a id="page_ii"></a><a id="page_iii">Here’s one for Don and Dana Carroll to peruse while they’re fixing Italy …</a></p><a id="page_iii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?41af05f2